import React from "react";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AppProvider } from "@toolpad/core/AppProvider";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import SearchIcon from "@mui/icons-material/Search";
import SearchBar from "../components/SearchBar";

const NAVIGATION = [
  { kind: "header", title: "" },

  {
    segment: "belge-sorgulama",
    title: "Belge Sorgulama",
    icon: <SearchIcon sx={{ color: "primary.main" }} />,
  },
];

const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#582b70" },
    secondary: { main: "#582b70" },
    background: { default: "#FFFFFF", paper: "#FFFFFF" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: "#fff",
          backgroundColor: "#582b70",
          "&:hover": { backgroundColor: "#4a245f" },
        },
      },
    },
  },
});

const BelgeSorgulama = () => {
  return (
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      <AppProvider
        navigation={NAVIGATION}
        branding={{
          logo: <img src="/tzv-logo.png" alt="tzv" />,
          title: "",
        }}
        theme={lightTheme}
      >
        <DashboardLayout>
          <Box
            sx={{
              py: 10,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              position: "relative",
            }}
          >
            <SearchBar />
          </Box>
        </DashboardLayout>
      </AppProvider>
    </ThemeProvider>
  );
};

export default BelgeSorgulama;